import React, { useEffect, useState } from "react";
import burger from "../../assets/logo/burger.svg";
import logo from "../../assets/logo/logo.png";
import close from "../../assets/logo/close.svg";
import BurgerNavigationMenu from "../../biblio/Tabs/BurgerNavigationMenu";
import { Divider } from "antd";
import TransparentButton from "../../biblio/Buttons/TransparentButton";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import MenuProfile from "../profile/menu/MenuProfile";
import { useCookies } from "react-cookie";

import { getBeneficiaryDetails } from "../../apis/actions/recipient.actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { getSponsorDetails } from "../../apis/actions/sponsor.actions";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  beneficiaryMenu,
  getMenu,
  schoolMenu,
  sponsorMenu,
  withOldSystemPayments,
  withParticipantMenu,
} from "../../data/MenuData";
import CardPalm from "../../components/card-palm/CardPalm";
import BasketComponent from "../../biblio/basket/BasketComponent";
import { isRoleEndower, isRoleSponsor } from "../profile/sponsor/orphans/utils";
import { getParticipantDetails } from "../../apis/actions/participants.actions";
import { getClub } from "../../apis/actions/scholarship.actions";
interface BurgerMenuProps extends React.HTMLAttributes<HTMLDivElement> {
  id?: string;
  variant?: string;
  palms: any;
}
const BurgerMenu = ({ variant, palms, ...props }: BurgerMenuProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [cookies, setCookie] = useCookies(["apiKey", "role", "visible"]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isBurgerOpened, setIsBurgerOpened] = useState(false);
  const [isProfileMenuVisible, setIsProfileMenuVisible] = useState(
    cookies?.visible ?? true
  );
  const role = cookies?.role;
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  const [selectedItemMenu, setSelectedItemMenu] = useState<string>(
    role === "beneficiary" ? "b1" : "s1"
  );

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isConnected = cookies?.apiKey ?? false;
  const beneficiary = useSelector(
    (state: RootState) => state?.recipient?.beneficiaryDetails
  );
  const sponsor = useSelector(
    (state: RootState) => state?.sponsor?.sponsorDetails
  );
  const { editMode } = useSelector((state: RootState) => state.recipient);

  const participantDetails = useSelector(
    (state: RootState) => state?.participants?.participantDetails
  );
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (editMode === true) {
      setIsBurgerOpened(false);
    }
  }, [editMode]);
  useEffect(() => {
    if (isBurgerOpened) {
      document.body.style.overflow = "hidden";
    } else {
      // Restore scrolling
      document.body.style.overflow = "";
    }
  }, [isBurgerOpened]);

  const handleMenuClick = (key: string) => {
    if (key === "b" || key === "s") {
      setIsProfileMenuVisible(false);
      setCookie("visible", false);
    }
  };
  useEffect(() => {
    setCookie("visible", isProfileMenuVisible);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProfileMenuVisible]);
  useEffect(() => {
    if (cookies.apiKey) {
      if (role === "beneficiary") {
        dispatch(getBeneficiaryDetails());
        dispatch(getClub());
      } else if (isRoleSponsor(role)) {
        dispatch(getSponsorDetails({ sponsor_id: OtpId }));
      } else {
        dispatch(getParticipantDetails());
      }
    }
  }, [dispatch, cookies.apiKey, role, OtpId]);

  const { club } = useSelector((state: RootState) => state.scholarship);

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        <figure
          className={`takaful--burger-menu-container burger-bg-color-blue `}
        >
          <img alt=""
            className="takaful--burger-btn-container"
            src={burger}
            onClick={() => {
              setIsBurgerOpened(!isBurgerOpened);
            }}
          />
        </figure>
        {isRoleSponsor(role) &&
          isMobile &&
          location.pathname === "/profile" && (
            <BasketComponent count={sponsor?.unpaid_booking_number} />
          )}
      </div>
      <nav
        {...props}
        className={`${
          isBurgerOpened ? "takaful--burger-menu-container-opened" : ""
        } ${props.className ? props.className : ""}`}
      >
        {isBurgerOpened && (
          <div className="takaful--burger-content">
            <div className="takaful--burger-header">
              <img alt=""
                className="takaful--burger-logo"
                src={logo}
                onClick={() => navigate("/")}
              />
              <img alt=""
                src={close}
                onClick={() => {
                  setIsBurgerOpened(false);
                }}
              />
            </div>
            <Divider className="takaful--burger-divider" />

            {isProfileMenuVisible && isConnected ? (
              <MenuProfile
                isExpanded={true}
                role={role}
                menu={
                  role === "beneficiary"
                    ? beneficiaryMenu(club)?.slice(
                        0,
                        beneficiaryMenu(club)?.length
                      )
                    : isRoleEndower(role)
                    ? getMenu(role)
                    : role === "school"
                    ? schoolMenu.slice(0, schoolMenu.length)
                    : withParticipantMenu(
                        withOldSystemPayments(
                          sponsorMenu.filter((item) => item.key !== "s15"),
                          sponsor
                        ),
                        role
                      )
                }
                handleMenuClickBurger={handleMenuClick}
                profileName={
                  role === "beneficiary"
                    ? beneficiary?.name
                    : isRoleEndower(role)
                    ? participantDetails?.name
                    : sponsor?.name
                }
                sponsor={sponsor}
                setSelectedItemMenu={(key) => {
                  setSelectedItemMenu(key);
                  key === "s" ||
                  key === "b" ||
                  key === "nb" ||
                  key === "nb1" ||
                  key === "ns1" ||
                  key === "ns2" ||
                  key === "nb4" ||
                  key === "nb3"
                    ? setIsBurgerOpened(true)
                    : setIsBurgerOpened(false);
                }}
                isFromBurger={true}
                selectedItemMenu={selectedItemMenu}
              />
            ) : (
              <>
                <BurgerNavigationMenu />
                <div className="takaful--burger-btn-container-profile"> {/*
                  <TransparentButton
                    className="takaful--return-button"
                    title={"الإنتقال إلى النسخة القديمة"}
                    onClick={() => {
                      window.location.href =
                        "https://takaful.soogp1.com/index.php?p=111";
                    }}
                  />*/}
                 
                  <TransparentButton
                    className="takaful--login-btn takaful--burger-button-profile"
                    icon={isConnected ? <ArrowLeftOutlined /> : null}
                    title={
                      isConnected ? (
                        <span className="takaful--title takaful--burger-span">
                          {isRoleSponsor(role)
                            ? sponsor?.name
                            : isRoleEndower(role)
                            ? participantDetails?.name
                            : beneficiary?.name}
                        </span>
                      ) : (
                        t("text-btn")
                      )
                    }
                    onClick={() => {
                      if (isConnected) {
                        navigate("/profile");
                        setIsProfileMenuVisible(true);
                        setCookie("visible", true);
                        setIsBurgerOpened(false);
                        isRoleSponsor(role) || isRoleEndower(role)
                          ? setSelectedItemMenu("s1")
                          : setSelectedItemMenu("b1");
                        window.scrollTo(0, 0);
                      } else {
                        navigate("/login");
                        setIsBurgerOpened(false);
                      }
                    }}
                  />
            {/*
                  <PrimaryButton
                    className="takaful--tansparent-button takaful--palm-button"
                    title="وقف النخيل"
                    direction="rtl"
                    icon={
                      <img
                        src={palm}
                        alt="folder"
                        width={28}
                        className="takaful--palm-icon"
                      />
                    }
                    onClick={() => setIsModalOpen(true)}
                  />*/}
                </div>
                <CardPalm
                  palms={palms}
                  isPalmModalOpen={isModalOpen}
                  setIsPalmModalOpen={(open: any) => setIsModalOpen(open)}
                />
              </>
            )}
          </div>
        )}
      </nav>
    </div>
  );
};

export default BurgerMenu;
